/* eslint-disable no-console */

import fetch from 'isomorphic-unfetch'
import getEnv from '../env'
import { playerApiRequest, playerApiReceive } from '../../actions'
import getApiUrl from '../getApiUrl'

export const customFetch = (url, callback) => {
  fetch(url)
    .then(response => response.json())
    .then(({ results }) => callback(results))
}

const dataApi = ctx => ({
  dispatch,
  path = '',
}) => {
  const headers = getHeaders(ctx)
  const environment = getEnv()
  const storeResponseInRedux = Boolean(dispatch)
  const url = buildRequestUrl({
    environment,
    path,
  })
  const request = () => {
    logRequest({ url, environment })

    return fetchWithTimeout({
      headers,
      url,
    })
  }

  if (storeResponseInRedux) {
    return dispatch(() => {
      dispatch(
        playerApiRequest(path)
      )
      return request()
        .then((response) => {
          dispatch(
            playerApiReceive({ path, response })
          )
          return response
        })
    })
  }

  return request()
}

export default dataApi

const getHeaders = ctx => ({
  ...(
    ctx?.req?.headers && {
      http_origin: ctx.req.headers.http_origin,
      'x-forwarded-for': ctx.req.headers['x-forwarded-for'],
    }
  ),
})

const logRequest = ({ url, environment }) => {
  if (environment === 'development' || environment === 'staging' || environment === 'testing') {
    console.log(`--- Request made to: ${url} | ${new Date()}`)
  }
}

export function buildRequestUrl({ environment, path }) {
  const base = environment === 'testing' ? `http://localhost:3000/mockDataApi${path}` : [
    'https://data.api.',
    getApiUrl(environment),
    '/v1',
    path,
  ].join('')
  return base
}

export function fetchWithTimeout({
  url = '',
  time = 5000,
  headers,
}) {
  const timeout = new Promise(resolve => setTimeout(() => {
    const error = {
      success: false,
      reason: `Timed out after ${time}ms: ${url}`,
    }
    resolve(error)
  }, time))
  return Promise.race([
    fetch(url, {
      headers,
    })
      .then(r => r.json()),
    timeout,
  ])
}
